import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import RelationshipForm from '../containers/RelationshipFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class RelationshipEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `RelationshipEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('relationship_route_edit')} />
          <RelationshipForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default RelationshipEditScreen;

Logger.log('silly', `RelationshipEditScreen loaded.`);
